import { useEffect, useState } from "react"
import { ChevronRight, Unlock } from "lucide-react"

import { OfferStepper } from "./offer-stepper"

function OfferCountdown() {
  const [seconds, setSeconds] = useState(9 * 60 + 45)

  useEffect(() => {
    const id = setInterval(() => setSeconds((s) => (s > 0 ? s - 1 : 0)), 1000)
    return () => clearInterval(id)
  }, [])

  const mm = String(Math.floor(seconds / 60)).padStart(2, "0")
  const ss = String(seconds % 60).padStart(2, "0")

  return (
    <div className="flex items-center justify-center gap-1">
      <span className="flex w-10 flex-col items-center justify-center rounded-[4px] bg-purple-light/10 py-0.5 font-display text-base font-medium text-purple-light">
        {mm}
      </span>
      <span className="text-sm font-medium text-purple-light/70">:</span>
      <span className="flex w-10 flex-col items-center justify-center rounded-[4px] bg-purple-light/10 py-0.5 font-display text-base font-medium text-purple-light">
        {ss}
      </span>
    </div>
  )
}

interface OfferStepperHeaderProps {
  offerLabels: string[]
  currentIndex: number
  unlockedLabel: string
  onSkip: () => void
}

/** Sticky funnel header: countdown + skip, the step progress bar, unlocked banner. */
export function OfferStepperHeader({
  offerLabels,
  currentIndex,
  unlockedLabel,
  onSkip,
}: OfferStepperHeaderProps) {
  return (
    <div data-slot="offer-stepper-header" className="flex flex-col">
      <div className="flex h-[54px] items-center justify-between border-b border-purple-light/10 bg-dark-base px-4 py-2">
        <div className="flex flex-col gap-0.5">
          <p className="text-center text-[8px] font-medium uppercase leading-[10px] text-purple-light/70">
            Offer expires in
          </p>
          <OfferCountdown />
        </div>
        <button
          type="button"
          onClick={onSkip}
          className="flex items-center rounded-[20px] bg-purple-light/10 py-1.5 pl-3 pr-2"
        >
          <span className="text-xs text-purple-light">Skip</span>
          <ChevronRight className="size-5 text-purple-light" />
        </button>
      </div>

      <OfferStepper offerLabels={offerLabels} currentIndex={currentIndex} />

      <div className="flex h-10 items-center justify-center gap-2 bg-green px-5">
        <Unlock className="size-5 text-dark-base" strokeWidth={2} />
        <span className="text-sm font-semibold text-dark-base">{unlockedLabel}</span>
      </div>
    </div>
  )
}
